<template>
  <div class="w-100 list-group mb-3  bg-white">
    <div class="py-3 mx-2 d-flex align-content-center justify-content-between border-bottom">
<!--      <div class="fw-bold w-auto my-0 lh-base h5" >基本信息 </div>-->
      <div class="fw-bold  my-0 lh-base h6" >个人中心 / 基本信息</div>
    </div>
<!--    <hr class=" my-1 mx-3"/>-->
    <h5 class="p-3 fw-bold">账户信息</h5>
    <!--    表单-->
    <div class="w-100" >
      <div class="row g-3 w-100">
        <div class="col-12 d-flex align-items-center justify-content-start">
          <label for="username" class="label-style" >头像：</label>
          <div class="header-input flex-shrink-0">
            <img :src="form.Avatar || url">
          </div>
          <div class="px-3 py-3 d-flex flex-column align-self-end">
            <form action="#" class="my-uploaded ml-3 d-flex align-items-start justify-content-end flex-column px-3"  method="post" enctype="multipart/form-data" ref="uploadForm" @change="uploadFile">
            <label for="pic" class="fw py-2" style="flex:none">
              <text  v-if="isUpLoading">{{uploadPercentCompleted}} % &nbsp;&nbsp;</text>
              <text class="text-primary fw-bold  point-curser">修改头像</text>
            </label>
            <text class="small text-secondary"> 支持jpg、png、jpeg格式，最大不超过1M</text>
            <input type="file" id="pic" accept="image/png, image/jpeg" name="pic" hidden>
            </form>
          </div>
        </div>
      </div>
      <form  class="row g-3 w-100" >
        <div class="col-12 d-flex align-items-center justify-content-start">
          <label for="username" class="label-style" >用户名：</label>
            <input type="text" class="form-control w-100 input-max-width"  disabled  :value="userInfo.Name" name="username" id="username" placeholder="请输入" required >
<!--          <button class="flex-shrink-0 mx-3  btn btn-sm btn-link text-decoration-none fw-bold " type="button" @click="change('userNameDisabled')" v-if="userNameDisabled">修改</button>-->
<!--          <button class="flex-shrink-0 mx-3  btn btn-sm btn-link text-decoration-none fw-bold" @click="change('userNameDisabled')" v-if="!userNameDisabled">取消</button>-->
        </div>
        <div class="col-12 d-flex align-items-center justify-content-start">
          <label for="tel" class=" label-style " >手机号：</label>
          <input type="tel" class="form-control w-100 input-max-width" disabled  :value="userInfo.Tel" name="tel" id="tel" placeholder="请输入" required >
<!--          <button class="flex-shrink-0 mx-3  btn btn-sm btn-link text-decoration-none fw-bold " @click="change('telDisabled')" v-if="telDisabled">修改</button>-->
<!--          <button class="flex-shrink-0 mx-3  btn btn-sm btn-link text-decoration-none fw-bold" @click="change('telDisabled')" v-if="!telDisabled">取消</button>-->
        </div>
        <div class="col-12 d-flex align-items-center justify-content-start">
          <label for="tel" class=" label-style " >密码：</label>
<!--          <input type="password" class="form-control w-100 input-max-width" :disabled="passwordDisabled"  v-model="form.password" name="password" id="password" placeholder="请输入" required >-->
          <button class="btn btn-primary btn-sm px-4" type="button" @click="changePassword">修改密码</button>
<!--          <button class="flex-shrink-0 mx-3  btn btn-sm btn-link text-decoration-none fw-bold " @click="change('passwordDisabled')" v-if="passwordDisabled">修改</button>-->
<!--          <button class="flex-shrink-0 mx-3  btn btn-sm btn-link text-decoration-none fw-bold" @click="change('passwordDisabled')" v-if="!passwordDisabled">取消</button>-->
        </div>
      </form>
    </div>
    <h5 class="p-3 fw-bold">个人资料</h5>
    <div class="w-100" >
      <form @submit.prevent="save" class="row g-3 w-100 needs-validation" novalidate>
        <div class="col-12 d-flex align-items-center justify-content-start">
          <label for="username" class=" label-style " >真实姓名：</label>
            <input type="text" class="form-control w-100 input-max-width"  v-model="form.RealName" name="username" id="username" placeholder="请输入" required >
        </div>
        <div class="col-12 d-flex align-items-center justify-content-start">
          <label for="tel" class=" label-style " >身份证号：</label>
            <input type="text" class="form-control w-100 input-max-width"  v-model="form.IdCard" name="tel" id="tel" placeholder="请输入" required >
        </div>
        <div class="col-12 d-flex align-items-center justify-content-start">
          <label for="tel" class=" label-style " >企业名称：</label>
            <input type="text" class="form-control w-100 input-max-width"  v-model="form.Company" name="tel" id="tel" placeholder="请输入" required >
        </div>
        <div class="col-12 d-flex align-items-center justify-content-center my-3">
          <button class="btn btn-primary px-4" :disabled="loading">
            保存
            <span v-if="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          </button>
        </div>
      </form>
    </div>
  </div>

  <changePasswordModel v-model:show="showChangePasswordModel" :tel="userInfo.Tel"></changePasswordModel>
<!--  &lt;!&ndash;没有数据&ndash;&gt;-->
<!--  <NodataCom :show="showNodata"></NodataCom>-->
<!--  &lt;!&ndash;  正在加载&ndash;&gt;-->
<!--  <LoadingCom :show="showLoading"></LoadingCom>-->
</template>

<script setup>
import changePasswordModel from "@/layout/changePasswordModel"
// import LoadingCom from "@/layout/LoadingCom"
import {computed, onMounted, reactive, ref} from "vue";
import {showToast} from "@/utils/toast";
import {uploadImage} from "@/api/uploadFile";
const uploadPercentCompleted = ref(0)
const isUpLoading = ref(false) // loading
const masterImage = require("../../assets/master.png")
const url = ref(masterImage)
const loading = ref(false)
const form = reactive({
  RealName:"", // 真实姓名
  IdCard:"", // 身份证号码
  Company:"", // 公司名称
  Avatar:masterImage,// 头像
})
import {useStore} from 'vuex'
import {accountUpdateInfo} from "@/api/login";
const store = useStore()
const showChangePasswordModel = ref(false) // 展示修改密码模态框
// const userInfo = computed(()=>{
//   return store.state.loginModel.userInfo
// }) // 用户信息
// const userInfo = ref({})
const userInfo = computed(()=>store.state.loginModel.userInfo) //身份信息
onMounted(()=>{
  getUserInfo()

})
// 获取用户信息
const getUserInfo = ()=>{
  userInfo.value = store.getters["loginModel/getUserInfo"] // 获取用户信息
  const {RealName,IdCard,Company,Avatar} = userInfo.value
  form.RealName = RealName
  form.IdCard = IdCard
  form.Company = Company
  form.Avatar = Avatar
}
//提交
const save =async (event)=>{
  var pattern = /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/;
  event.preventDefault();
  event.stopPropagation();
  if(form.IdCard && !pattern.test(form.IdCard)){ // 存在身份证号码的时候，验证身份证号码的正确性
    return showToast("warning","您的身份证输入有误")
  }
  loading.value = true
  const res = await accountUpdateInfo(form)
  loading.value = false
  if(res.err_code===0){
   await store.dispatch("loginModel/getUserInfo") // 更新用户信息
    getUserInfo() // 重新获取信息
  }else{
    showToast("danger",res.err_msg || "修改失败")
  }


}

// 修改密码
const changePassword = ()=>{
 showChangePasswordModel.value = true
}


// 上传文件
const uploadFile =async (event)=>{
  function getProcess(progressEvent,pf) {
    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    uploadPercentCompleted.value = percentCompleted
  }
  try {
    let fs = event.target.files?event.target.files[0]:""
    if(!fs) return
    if(fs.size / 1024 / 1024 > 1){// 1M
      return showToast("warning","您上传的照片大于1M")
    }
    let binary = new FormData()
    binary.append('file',fs)
    binary.append('name',fs.name)
    isUpLoading.value = true
    uploadPercentCompleted.value = 0
    const res = await uploadImage(binary,fs,getProcess)
    isUpLoading.value = false
    const resData = res.data || {}
    if (resData.err_code === 0) {
      // 头像上传成功
      const updataParams = {RealName:userInfo.value.RealName,
        IdCard:userInfo.value.IdCard,
        Company:userInfo.value.Company,
        Avatar:resData.data}
      const upres = await accountUpdateInfo(updataParams)
      if(upres.err_code === 0){
        form.Avatar = resData.data
        store.dispatch("loginModel/getUserInfo") // 更新用户信息
        return showToast("success","上传成功")
      }else{
        showToast("danger",upres.err_msg || "修改失败")
      }
    }else{
      return showToast("danger","上传失败")
    }
  }catch (error){
    return showToast("err",error)
  }



  // const fileSize = this.files[0].size;
}

</script>

<style scoped lang="scss">
.label-style{
 display: inline;
  width: 100px;
  text-align: right;
  height: 1rem;
  line-height: 1rem;
  @media (max-width: 992px) {
    display: block;
  }

}
strong{
  font-weight: 800;
}

.header-input{
  width: 100px;
  height: 120px;
  border: 1px solid #ddd;
}
.header-input img{
  width: 100%; /* 图片宽度适配 */
  height: 100%; /* 图片高度适配 */
  object-fit: contain;
}
.input-max-width{
  width: 300px !important;
}

</style>
